<template>
	<p
		class="title font-weight-light mb-5 mt-5"
		style="line-height: 1.7 !important;"
	>
		<slot />
	</p>
</template>

<script>
export default {
	name: 'BaseText',
}
</script>
